import { IGetObraChecklistServicosDropDownUseCase } from "../../../presentation/useCases/read/get_obra_checklist_servicos_drop_down_use_case";
import { ObraChecklistServicoDropDown } from "../../models/obra_checklist_servico_dropdown";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * GetObraChecklistServicosDropDownUseCase
 */

export class GetObraChecklistServicosDropDownUseCase implements IGetObraChecklistServicosDropDownUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async getObraChecklistServicosDropDown(
    idObra: number,
    tipoServico: string | null,
    idsObraAreaChecklist: number[] | undefined,
    usedOnly: boolean | undefined,
  ): Promise<ObraChecklistServicoDropDown[]> {
    return this.repository.getObraChecklistServicosDropDown(
      idObra,
      tipoServico,
      idsObraAreaChecklist ?? null,
      usedOnly ?? null,
    );
  }
}